import { render } from "./SmsNotReceivedHint.vue?vue&type=template&id=d2af6c3a&lang=pug"
import script from "./SmsNotReceivedHint.vue?vue&type=script&lang=js"
export * from "./SmsNotReceivedHint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__